







































import Vue from "vue";
import moment from "moment";
import Component from "vue-class-component";

import { Prop, Emit } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

import { User } from "@/store/modules/auth/types";
import { Author } from "@/store/content";

const namespace: string = "reply";

@Component
export default class ReplyDetails extends Vue {
  @Prop() author!: Author;
  @Prop() date!: string;
  @Prop() replyPublicId!: string;
  @Prop() edited!: boolean;

  @Getter("currentUser", { namespace: "auth" }) private currentUser!: User;

  @Action("delete", { namespace: "reply" })
  private delete!: Function;

  @Action("setSnackNotifier", { namespace: "dialog" })
  private setSnackNotifier!: Function;

  private menuActions: object[] = [
    {
      label: "Edit",
      action: this.editReply
    },
    {
      label: "Delete",
      action: this.deleteReply
    },
    {
      label: "Report",
      action: () => null
    }
  ];

  @Emit("edit")
  private editReply() {
    return true;
  }

  private async deleteReply() {
    const isDeleted: boolean = await this.delete(this.replyPublicId);

    // Self immolate if succeeded.
    if (isDeleted) {
      // Notify
      this.setSnackNotifier({
        color: "orange darken-3",
        message: "Reply has been deleted!"
      });

      this.$emit("deleted");
    }
  }

  private modifiable(label: string): boolean {
    const ignore = ["Report"];

    if (!ignore.includes(label)) {
      return this.currentUser.public_id === this.author.public_id
        ? true
        : false;
    }

    return true;
  }

  private get prettyDate(): string {
    const prettyDate: string = moment
      .utc(this.date)
      .local()
      .fromNow();

    return prettyDate;
  }
}
